import "@hotwired/turbo-rails";
import * as Tabler from "@tabler/core/dist/js/tabler.js";

import "../../javascript/controllers";

const { Dropdown } = Tabler;

const usersRowDropdownSelector = ".js-users-row-dropdown-toggle";
const dropdownToggleSelector = "[data-bs-toggle='dropdown']";

const resetDropdownMenuStyles = (menu) => {
  menu.classList.remove("show");
  menu.removeAttribute("data-popper-placement");
  menu.removeAttribute("data-bs-popper");
  menu.style.removeProperty("position");
  menu.style.removeProperty("inset");
  menu.style.removeProperty("transform");
  menu.style.removeProperty("top");
  menu.style.removeProperty("left");
  menu.style.removeProperty("margin");
  menu.style.removeProperty("will-change");
};

const resetDropdownState = (toggle, dispose = false) => {
  const bootstrapDropdown = Dropdown;
  const menu = toggle.closest(".dropdown")?.querySelector(".dropdown-menu");

  if (bootstrapDropdown) {
    const instance = bootstrapDropdown.getInstance(toggle);
    if (instance) {
      instance.hide();
      if (dispose) instance.dispose();
    }
  }

  toggle.setAttribute("aria-expanded", "false");
  if (menu) resetDropdownMenuStyles(menu);
};

const initDropdowns = () => {
  const bootstrapDropdown = Dropdown;
  if (!bootstrapDropdown) return;

  document.querySelectorAll(dropdownToggleSelector).forEach((toggle) => {
    resetDropdownState(toggle, true);

    if (toggle.matches(usersRowDropdownSelector)) {
      new bootstrapDropdown(toggle, {
        boundary: "viewport",
        popperConfig(defaultConfig) {
          return { ...defaultConfig, strategy: "fixed" };
        },
      });
      return;
    }

    new bootstrapDropdown(toggle);
  });
};

document.addEventListener("turbo:load", initDropdowns);
document.addEventListener("turbo:render", initDropdowns);
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initDropdowns, { once: true });
} else {
  initDropdowns();
}

document.addEventListener("turbo:before-cache", () => {
  const toggles = document.querySelectorAll(dropdownToggleSelector);

  toggles.forEach((toggle) => {
    if (Dropdown) {
      const instance = Dropdown.getInstance(toggle) || Dropdown.getOrCreateInstance(toggle);
      instance.hide();
      instance.dispose();
    }
    toggle.setAttribute("aria-expanded", "false");
  });

  document.querySelectorAll(".dropdown-menu.show").forEach((menu) => {
    menu.classList.remove("show");
  });

  document.querySelectorAll(".dropdown-menu").forEach((menu) => {
    resetDropdownMenuStyles(menu);
  });
});
